import PostCheckout from '@/pages/editor/components/modals/PostCheckout';
import { Billing } from '@/services/api';
import { useAuth } from '@/services/auth';
import { PlanGroup } from '@d-id/types';
import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

interface Props {
    isPostCheckoutOpen: boolean;
    setIsPostCheckoutOpen: (isOpen: boolean) => void;
}

export const PostFirstCheckoutModal = ({ isPostCheckoutOpen, setIsPostCheckoutOpen }: Props) => {
    const { state } = useLocation();
    const { user } = useAuth();
    const params = useSearchParams()[0];
    const purchase = params.get('purchase');

    useEffect(() => {
        if (purchase === 'success') setIsPostCheckoutOpen(true);
    }, [purchase]);

    if (!isPostCheckoutOpen) return null;

    const priceId = params.get('price_id') || undefined;
    const plan = params.get('plan') as PlanGroup | undefined;
    const billing = (params.get('billing') || user?.billingInterval) as Billing | undefined;

    if (purchase === 'success') {
        return (
            <PostCheckout
                isNewSubscription
                onClose={() => setIsPostCheckoutOpen(false)}
                requestedPriceId={priceId}
                requestedPlan={plan}
                requestedBilling={billing}
            />
        );
    }

    return (
        <PostCheckout
            onClose={() => setIsPostCheckoutOpen(false)}
            requestedPlan={state?.newPlan as PlanGroup}
            requestedBilling={state?.newInterval as Billing}
            requestedPriceId={state?.newPriceId}
        />
    );
};
